import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import { useQueryClient } from '@tanstack/react-query';
import { Field, Formik, Form } from 'formik';
import React from 'react';
import TextFormField from 'v2/components/Shared/FormFields/TextFormField';
import eduzzAccountsService from 'v2/services/eduzzAccount';

import type { SubscriptionPlan } from 'v2/interfaces/product';

import { useStyles } from './styles';
import { validationSchema } from './validation';

import type { FormValues } from './constants';
import type IProduct from 'interfaces/IProduct';
type ModalProps = {
  openModal: boolean;
  handleCloseModal: () => void;
  planId: number;
  product: IProduct;
  membershipFee: boolean;
  updateProduct: (product: IProduct) => void;
};

export const ComissionModal = ({ openModal, product, handleCloseModal, planId, membershipFee, updateProduct }: ModalProps) => {
  const classes = useStyles();

  const isBetaSubscriptionsFirstInvoice = eduzzAccountsService.verifyUserHasBetaModule('comissao-primeira-fatura');
  const queryClient = useQueryClient();

  const plan = product.plan.find((data) => data.plan_id === planId);
  function onSubmit({ membership_comission_value, recurring_comission_value }: FormValues) {
    const updatedPlans = product.plan.map((data) => {
      if (data.plan_id === planId) {
        return { ...data, membership_comission_value, recurring_comission_value };
      }

      return data;
    });

    queryClient.setQueryData<SubscriptionPlan[]>(['product', product.id, 'plans'], (plans) =>
      plans.map((data) => {
        if (data.plan_id === planId) {
          return { ...data, plan_reccomissao_valor: recurring_comission_value, plan_comissao_valor: membership_comission_value };
        }

        return data;
      })
    );

    updateProduct({ ...product, plan: updatedPlans });
    handleCloseModal();
  }

  return (
    <Dialog open={openModal} onClose={handleCloseModal} maxWidth='md' fullWidth>
      <DialogTitle>Editar comissões: Assinatura plano semestral</DialogTitle>
      <Formik
        initialValues={{
          membership_comission_value: plan?.membership_comission_value || 1,
          recurring_comission_value: plan?.recurring_comission_value || 1,
        }}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
      >
        {({ handleSubmit }) => (
          <>
            <DialogContent className={classes.container}>
              <Form>
                <div>
                  <h2 className={classes.switchTitle}>Comissão recorrente</h2>
                  <p className={classes.subtitle}>
                    O Afiliado recebe uma porcentagem a cada parcela paga pelo seu cliente indicado.{' '}
                    <a
                      href='https://ajuda.eduzz.com/hc/pt-br/articles/1260807002269-Como-funciona-a-comissão-por-recrutamento-de-Afiliado-'
                      target='_blank'
                      rel='noreferrer'
                    >
                      Saiba Mais.
                    </a>
                  </p>
                </div>

                <Field
                  name='recurring_comission_value'
                  label='Digite o valor da porcentagem da venda do produto que será destinado ao afiliado'
                  fullWidth
                  mask='percent'
                  startAdornment='%'
                  style={{ marginTop: 20 }}
                  component={TextFormField}
                />

                {!!membershipFee && (
                  <>
                    <div style={{ marginTop: 40 }}>
                      <p className={classes.switchTitle}>{isBetaSubscriptionsFirstInvoice ? 'Primeira fatura' : 'Comissão de adesão'}</p>
                      <p className={classes.subtitle}>
                        O Afiliado recebe uma porcentagem da comissão de adesão, paga pelo cliente indicado. Saiba Mais
                      </p>
                    </div>

                    <Field
                      name='membership_comission_value'
                      label='Digite o valor da porcentagem da venda do produto que será destinado ao afiliado'
                      fullWidth
                      mask='percent'
                      startAdornment='%'
                      style={{ marginTop: 20 }}
                      component={TextFormField}
                    />
                  </>
                )}
                <Alert severity='info' style={{ marginTop: 40 }}>
                  <p>Comissão com percentual do ganho bruto. </p>
                  <p>Planos com valores promocionais, será aplicada o valor base da comissão recorrente.</p>
                </Alert>
              </Form>
            </DialogContent>

            <DialogActions>
              <Button variant='outlined' onClick={handleCloseModal}>
                Cancelar
              </Button>
              <Button variant='contained' color='primary' onClick={() => handleSubmit()}>
                Salvar
              </Button>
            </DialogActions>
          </>
        )}
      </Formik>
    </Dialog>
  );
};
